/**
 * 热榜 API 统一配置
 * 全部走各家官方 API（不再依赖 newsnow 公共代理，稳定性更可控）
 * vue.config.js 里已为每个平台配置独立代理前缀
 */

/**
 * 平台到 newsnow source id 的映射
 * id 命名遵循 newsnow 公开约定
 */
export const PLATFORM_NEWSNOW_ID = {
  weibo: 'weibo',
  zhihu: 'zhihu',
  baidu: 'baidu',
  bilibili: 'bilibili-hot-search',
  douyin: 'douyin',
  toutiao: 'toutiao',
  thepaper: 'thepaper',
  '36kr': '36kr',
  hupu: 'hupu',
  ithome: 'ithome',
  wallstreetcn: 'wallstreetcn-hot',
  cls: 'cls-hot',
  sspai: 'sspai',
  sina: 'sina',
  v2ex: 'v2ex',
  hackernews: 'hackernews',
  github: 'github-trending',
  kuaishou: 'kuaishou',
  producthunt: 'producthunt',
  juejin: 'juejin',
  solidot: 'solidot',
}

/**
 * 统一代理前缀（指向项目里已有的 /api-proxy -> newsnow.busiyi.world）
 */
export const PROXY_PREFIX = '/api-proxy/api/s?id='

/**
 * 平台配置：包含 name / icon / newsnowId
 * 移除不可靠的（虎嗅、产品经理、抖音个别情况）
 */
export const PLATFORM_LIST = [
  { id: 'weibo',       name: '微博热搜',   icon: '🔥', newsnowId: 'weibo' },
  { id: 'zhihu',       name: '知乎热榜',   icon: '💡', newsnowId: 'zhihu' },
  { id: 'baidu',       name: '百度热搜',   icon: '🔍', newsnowId: 'baidu' },
  { id: 'bilibili',    name: 'B站热门',    icon: '📺', newsnowId: 'bilibili-hot-search' },
  { id: 'douyin',      name: '抖音热点',   icon: '🎵', newsnowId: 'douyin' },
  { id: 'toutiao',     name: '今日头条',   icon: '📰', newsnowId: 'toutiao' },
  { id: 'thepaper',    name: '澎湃新闻',   icon: '📋', newsnowId: 'thepaper' },
  { id: '36kr',        name: '36氪',       icon: '🚀', newsnowId: '36kr' },
  { id: 'hupu',        name: '虎扑热帖',   icon: '🏀', newsnowId: 'hupu' },
  { id: 'ithome',      name: 'IT之家',     icon: '💻', newsnowId: 'ithome' },
  { id: 'wallstreetcn', name: '华尔街见闻', icon: '📈', newsnowId: 'wallstreetcn-hot' },
  { id: 'cls',         name: '财联社',     icon: '💰', newsnowId: 'cls-hot' },
]

/**
 * 通用获取函数
 * @param {string} newsnowId newsnow source id
 * @returns {Promise<Array>} 标准化后的热榜列表
 */
export async function fetchHotById(newsnowId) {
  const url = `${PROXY_PREFIX}${newsnowId}`
  const response = await fetch(url, {
    headers: { Accept: 'application/json' },
  })
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`)
  }
  const json = await response.json()
  const items = Array.isArray(json?.items) ? json.items : []
  return items.map((v) => ({
    id: v.id || v.title,
    title: v.title,
    url: v.url || v.mobileUrl || '#',
    mobileUrl: v.mobileUrl || v.url || '#',
    hot: v.extra?.info || '',
    icon: v.extra?.icon || '',
  }))
}

/**
 * 旧 PLATFORM_API_MAP 兼容导出
 */
export const PLATFORM_API_MAP = PLATFORM_LIST.reduce((acc, p) => {
  acc[p.id] = p.newsnowId
  return acc
}, {})
